export class PermissionsModel {
    deletable = false;
    updatable = false;
    permissions: string[] = [];
}

export enum PermissionDefault {
    UPDATE = 'UPDATE',
    DELETE_BY_ID = 'DELETE_BY_ID',
    FIND_BY_ID = 'FIND_BY_ID'
}
